// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import StreamAudioLayout from './StreamAudioLayout';

export default StreamAudioLayout;
